import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
  } from '@angular/core';
import { DatePickerOptions } from './datepicker-options';
import { isUndefined } from 'util';


@Component({
  selector: 'nec-date-picker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})

export class NecDatePickerComponent implements OnInit, OnChanges {

  /**
   * æ¥æ
   */
  @Input() dateValue: Date;

  /**
   * æ¥æç»ä»¶éç½®
   */
  @Input() datePickerConfig?: DatePickerOptions;

  /**
   * åä¸ä¸ªæ¥æç»ä»¶çå¼
   */
  @Input() prePicker?: Date;

  /**
   * åä¸ä¸ªæ¥æç»ä»¶çå¼
   */
  @Input() backPicker?: Date;

  /**
   * æ¥æå¼ååäºä»¶
   */
  @Output() dateValueChange = new EventEmitter<Date>();

  @ViewChild('pCalendar') pCalendar: ElementRef;

  customConfig = new DatePickerOptions();

  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
    this.setDatePickerConfig(this.datePickerConfig);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('prePicker') && !isUndefined(this.prePicker)) {
      this.renderer.setProperty(this.pCalendar, 'maxDate', this.prePicker);
    }
    if (changes.hasOwnProperty('backPicker') && !isUndefined(this.backPicker)) {
      this.renderer.setProperty(this.pCalendar, 'minDate', this.backPicker);
    }
  }

  updateValue() {
    this.dateValueChange.emit(this.dateValue);
  }

  /**
   * æ§ä»¶éæ©äºä»¶
   */
  dateValueSelect() {
    if (this.prePicker) {
      if (this.prePicker.getTime() <= this.dateValue.getTime()) {
        this.dateValue = new Date(this.prePicker);
      }
    }
    if (this.backPicker) {
      if (this.backPicker.getTime() >= this.dateValue.getTime()) {
        this.dateValue = new Date(this.backPicker);
      }
    }
    this.dateValueChange.emit(this.dateValue);
  }

  /**
   * æ§ä»¶bluräºä»¶
   */
  dateValueBlur() {
    if (this.prePicker && this.dateValue && this.dateValue.getTime() > this.prePicker.getTime()) {
      this.dateValue = null;
    }
    if (this.backPicker && this.dateValue && this.dateValue.getTime() < this.backPicker.getTime()) {
      this.dateValue = null;
    }
    this.dateValueChange.emit(this.dateValue);
  }

  /**
   * setæ§ä»¶éç½®
   */
  setDatePickerConfig(config: DatePickerOptions) {
    if (config instanceof Object) {
      for (const option of Object.keys(this.customConfig)) {
        this.customConfig[option] = config[option] != null ? config[option] : this.customConfig[option];
        this.renderer.setProperty(this.pCalendar, option, this.customConfig[option]);
      }
    }
    else {
      for (const option of Object.keys(this.customConfig)) {
        this.renderer.setProperty(this.pCalendar, option, this.customConfig[option]);
      }
    }
    if (!isUndefined(this.prePicker)) {
      this.renderer.setProperty(this.pCalendar, 'maxDate', this.prePicker);
    }
    if (!isUndefined(this.backPicker)) {
      this.renderer.setProperty(this.pCalendar, 'minDate', this.backPicker);
    }
  }
}


